import React from 'react';
import './Header.css'

const Header = () => {
    return (
        <div className="header-part">
            <h1>Pigeon House For Pigeons Lover</h1>
            <small>Pigeons lovers never attectd by bad activities</small>
            <h2>Total Budget :$500 </h2>
        </div>
    );
};

export default Header;